let Product = {
    primaryColorShade: '#836AF9',
    yellowColor: '#ffe800',
    successColorShade: '#28dac6',
    warningColorShade: '#ffe802',
    warningLightColor: '#FDAC34',
    infoColorShade: '#299AFF',
    greyColor: '#4F5D70',
    blueColor: '#2c9aff',
    blueLightColor: '#84D0FF',
    greyLightColor: '#EDF1F4',
    tooltipShadow: 'rgba(0, 0, 0, 0.25)',
    lineChartPrimary: '#666ee8',
    lineChartDanger: '#ff4961',
    labelColor: '#6e6b7b',
    gridLineColor: 'rgba(200, 200, 200, 0.2)',

    init: function () {
        this.bind();
    },

    bind: function () {
        if ($('.chartjs').length) {
            this.chart();
        }

        if ($('#productForm').length) {
            this.toggleNotifications();
            this.toggleNotifyValue();

            $(document).on('change.bootstrapSwitch', '#enableNotifications', () => {
                this.toggleNotifications();
            });

            $(document).on('change', '#notifyCondition', () => {
                this.toggleNotifyValue();
            });
        }
    },

    chart() {
        let chartWrapper = $('.chartjs')
        if (chartWrapper.length) {
            chartWrapper.each(function () {
                $(this).wrap($('<div style="height:' + this.getAttribute('data-height') + 'px"></div>'));
            });
        }
        let chart = $("#priceChart");
        console.log(chartOptions);
        let chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                position: 'top',
                align: 'start',
                labels: {
                    usePointStyle: true,
                    padding: 25,
                    boxWidth: 9
                }
            },
            layout: {
                padding: {
                    top: -20,
                    bottom: -20,
                    left: -20
                }
            },
            tooltips: {
                // Updated default tooltip UI
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowBlur: 8,
                shadowColor: this.tooltipShadow,
                backgroundColor: window.colors.solid.white,
                titleFontColor: window.colors.solid.black,
                bodyFontColor: window.colors.solid.black
            },
            scales: {
                x: [
                    {
                        display: true,
                        gridLines: {
                            color: 'transparent',
                            zeroLineColor: this.gridLineColor
                        },
                        scaleLabel: {
                            display: true
                        },
                        ticks: {
                            fontColor: this.labelColor
                        },
                        type: 'time',
                    }
                ],
                y: [
                    {
                        display: true,
                        gridLines: {
                            color: 'transparent',
                            zeroLineColor: this.gridLineColor
                        },
                        ticks: {
                            stepSize: 300,
                            min: 0,
                            // max: 400,
                            fontColor: this.labelColor,
                            ticks: {
                                beginAtZero: true,
                                callback: function(value) {if (value % 1 === 0) {return value;}}
                            }
                        },
                        scaleLabel: {
                            display: true
                        },
                        beginAtZero: true
                    }
                ]
            }
        };
        let chartData = {
            labels: window.dates,
            datasets: [
                {
                    label: 'Price',
                    data: window.prices,
                    lineTension: 0,
                    backgroundColor: this.primaryColorShade,
                    pointStyle: 'circle',
                    borderColor: this.primaryColorShade,
                    fill: false,
                    pointRadius: 3,
                    pointHoverRadius: 5,
                    pointHoverBorderWidth: 2,
                    pointBorderColor: 'transparent',
                    pointHoverBackgroundColor: this.primaryColorShade,
                    pointHoverBorderColor: this.primaryColorShade
                }
            ]
        };

        let config = {
            type: 'line',
            plugins: [
                // to add spacing between legends and chart
                {
                    beforeInit: function (chart) {
                        chart.legend.afterFit = function () {
                            this.height += 20;
                        };
                    }
                }
            ],
            // Chart Options
            options : {},
            data : chartData
        };

        let lineChart = new Chart(chart, config);
    },

    toggleNotifications() {
        const notificationsEnabled = $('#enableNotifications').prop('checked');
        const notificationsContainer = $('#notificationsContainer');

        if (notificationsEnabled) {
            notificationsContainer.show();
        } else {
            notificationsContainer.hide();
        }
    },

    toggleNotifyValue() {
        const notifyCondition = $('#notifyCondition option:selected').val();
        const notifyValue = $('#notifyValue').closest('div');

        if (notifyCondition === 'dropped' || notifyCondition === 'raised') {
            notifyValue.hide();
        } else {
            notifyValue.show();
        }
    }
};


$().ready(() => {
    window.Frontend.Product = Product;
    window.Frontend.Product.init();
});
